import Vue from 'vue';

class UserService {

  constructor() {
    this.userToken = null;
  }

  get token() {
    return this.userToken || Vue.$cookies.get('token');
  }

  set token(token) {
    this.userToken = token;
  }

  // eslint-disable-next-line class-methods-use-this
  login(authToken) {
    document.cookie = `token=${authToken};domain=.mpay.az;path=/`;
    this.token = authToken;
  }

  logout() {
    Vue.$cookies.remove('token');
    document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.mpay.az;path=/';
    this.token = null;
    return '';
  }

}

const userService = new UserService();
export { userService as UserService };
